import React from 'react';
import LocalParticipant from './LocalParticipant';
import MainParticipant from './MainParticipant';
import ReconnectingNotification from './ReconnectingNotification';
export default function Room(_ref) {
  var showOverlays = _ref.showOverlays,
      videoProcessor = _ref.videoProcessor;
  return /*#__PURE__*/React.createElement("div", {
    id: "Room",
    style: {
      position: 'relative',
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(MainParticipant, {
    showOverlays: showOverlays
  }), /*#__PURE__*/React.createElement(LocalParticipant, {
    videoProcessor: videoProcessor
  }), /*#__PURE__*/React.createElement(ReconnectingNotification, null));
}